<template>
  <div class="DailyClock">
    <AppHeader>每日打卡</AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="类别">
            <el-select
                style="width: 150px"
                v-model="filter.type"
                placeholder="请选择"
                @change="onSubmit"
            >
              <el-option
                  v-for="item in clockTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传时间">
            <el-date-picker
                style="width: 250px"
                v-model="filter.dateRange"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
                v-model="filter.keyword"
                placeholder="名称 | 课程名称"
                @keyup.enter.native="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <el-button type="primary" plain @click="handleAddClock"
                     v-show="permissionCode.has('plugin:knowledge:manager')"
          >新增打卡
          </el-button>
        </div>
      </div>
      <ClockList :maxHeight="maxHeight"></ClockList>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import {CLOCK_TYPE} from "@/utils/constants";
import {mapActions, mapMutations, mapState} from "vuex";
import ClockList from "@/pages/DailyClock/ClockList.vue";
import {mapStates} from "element-ui/packages/table/src/store/helper";

export default {
  name: "DailyClock",
  components: {ClockList, AppBox, AppHeader},
  data() {
    const clockTypeOptions = Object.keys(CLOCK_TYPE).map((key) => {
      return {
        value: Number(key),
        label: CLOCK_TYPE[key],
      };
    });
    return {
      clockTypeOptions: [
        {
          value: null,
          label: "全部",
        },
        ...clockTypeOptions,
      ],
      maxHeight: null,
    };
  },
  computed: {
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.pluginCenter.knowledgeListFilter;
      },
      set(value) {
        this.$store.commit("pluginCenter/setData", {
          key: "knowledgeListFilter",
          value,
        });
      },
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    ...mapActions("pluginCenter", ["getKnowledgeList"]),
    ...mapMutations("pluginCenter", ["clearFilter"]),
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.56;
        } else {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.39;
        }
      });
    },
    async handleAddClock() {
      await this.$router.push({
        name: "AddClock",
        params: {
          type: "add",
          id: 0,
        },
      });
    },
    async onSubmit() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getKnowledgeList({
            ...this.filter,
            page: 1,
          });
        }
      });
    },
    // 重置
    async onReset() {
      await this.clearFilter();
      // this.$set(this.filter, "departmentId", this.userDepartmentDictionary[0].id)
      await this.getKnowledgeList({
        page: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.DailyClock {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }
  }
}
</style>
